import React from 'react';
import { CheckIcon } from 'lucide-react';
const capabilities = ['Embedded Linux and RTOS development', 'Hardware interface programming', 'Industrial control systems', 'Data acquisition and monitoring', 'Protocol implementation', 'Performance optimization for constrained environments'];
export function Capabilities() {
  return <section className="py-16" data-id="element-466">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-467">
        <div className="scroll-fade-in-up" data-id="element-468">
          <div className="bg-surface rounded-xl p-8 md:p-12" data-id="element-469">
            <h2 className="text-2xl font-bold text-ink mb-4" data-id="element-470">
              Key Capabilities
            </h2>
            <p className="text-gray-600 mb-8 leading-relaxed" data-id="element-471">
              Our embedded systems engineering team excels in developing robust,
              low-level software for a wide range of hardware platforms and
              industrial applications. We focus on optimizing performance,
              ensuring real-time responsiveness, and implementing secure
              communication protocols for mission-critical systems.
            </p>
            <ul className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-472">
              {capabilities.map((cap, i) => <li key={i} className="flex items-start" data-id="element-473">
                  <CheckIcon className="w-5 h-5 text-primary mr-3 mt-0.5 flex-shrink-0" data-id="element-474" />
                  <span className="text-gray-700" data-id="element-475">{cap}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}